export const inventoryItemSelector = ({ inventory }) => inventory.inventoryItem;
export const inventoryLoaderSelector = ({ inventory }) => inventory.loader;
export const inventoryCreatedProductSelector = ({ inventory }) => inventory.createdProduct;
